<template>
  <div class="checkbox-wrapper">
    <input
      type="checkbox"
      :id="id"
      :name="id"
      class="checkbox"
      v-bind="$attrs"
      v-on="listeners"
      :disabled="disabled"
      :checked="value"
    />
    <label :for="id" class="d-flex align-center">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    label: {
      type: String,
      default: ""
    },
    id: String,
    disabled: Boolean
  },
  computed: {
    listeners() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event.target.checked);
          }
        }
      );
    }
  }
};
</script>
